import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CreateVehicle from "./CreateVehicle";
import UserService from "services/UserService";
import axios from "axios";
import { getVehicles } from "services/ConfigServices";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import { vehiclespagetext } from "variables/vehicles";
import { statusData, motorData, energyData } from "variables/lists/vehicles";
import moment from "moment";
import ChartV2, { getChartCategoryScriptV2 } from "components/ChartV2/ChartV2";
import { number } from "prop-types";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export default function useVehiclesTableQuery() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const vehiclesadmin = permis.includes("vehicles_admin");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getVehicles(chartIdGroup);
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [vehiclesdata, setVehiclesdata] = useState({});
  const [graphdatebegin, setGraphdatebegin] = useState(moment().subtract(1, 'year').format("YYYY-MM-DD"));
  const [graphdateend, setGraphdateend] = useState(moment().format("YYYY-MM-DD"));
  const [chart1, setChart1] = useState();
  const [chart2, setChart2] = useState();
  const [chartcount, setChartcount] = useState(0);
  const [filtereditemwithdata, setFiltereditemwithdata] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setVehiclesdata(response.data.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);



  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);


  useEffect(() => {
    setChart1("");
    setChart2("");
    if (!filteredItems || filteredItems.length == 0) {
     
    }
    else {
      let chartcounttmp = chartcount+1;
      // console.log(selectedVehicles);
      // console.log(filteredItems);
      // let selectedids = selectedVehicles.map((obj)=>''+obj.id);
      // if(selectedids && selectedids.length>0)
      // {
      //   let filtereddata = vehiclesdata?.filter((obj)=>ob)
      // }

      let vehiclestmp = selectedVehicles.length > 0 ? selectedVehicles : filteredItems;
      // console.log(vehiclestmp);

      let datacostbymotor = {
        "essence": [], "hybrideessence": [], "hybriderecessence": [], "diesel": [], "hybridediesel": [],
        "hybriderecdiesel": [], "electrique": [], "hydrogene": [], "biogaz": []
      };
      let datacostbyenergy = {
        "SP95": [], "SP98": [], "diesel": [],
        "hydrogen": [], "biogas": [], "electricity": [], "ethanol": []
      };
      let datakmbymotor = {
        "essence": [], "hybrideessence": [], "hybriderecessence": [], "diesel": [], "hybridediesel": [],
        "hybriderecdiesel": [], "electrique": [], "hydrogene": [], "biogaz": []
      };
      let datakmbyenergy = {
        "SP95": [], "SP98": [], "diesel": [],
        "hydrogen": [], "biogas": [], "electricity": [], "ethanol": []
      };
      let mindates2;
      let maxdates2;
      vehiclestmp.forEach((vehicle) => {
        if (vehiclesdata["" + vehicle.id]) {
          if (vehiclesdata["" + vehicle.id]["1464"]) {
            vehiclesdata["" + vehicle.id]["1464"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datacostbymotor[vehicle.parameters.motor].push({ ...data });
                datacostbyenergy["SP95"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1469"]) {
            vehiclesdata["" + vehicle.id]["1469"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datacostbymotor[vehicle.parameters.motor].push({ ...data });
                datacostbyenergy["SP98"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1474"]) {
            vehiclesdata["" + vehicle.id]["1474"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datacostbymotor[vehicle.parameters.motor].push({ ...data });
                datacostbyenergy["diesel"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1479"]) {
            vehiclesdata["" + vehicle.id]["1479"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datacostbymotor[vehicle.parameters.motor].push({ ...data });
                datacostbyenergy["hydrogen"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1484"]) {
            vehiclesdata["" + vehicle.id]["1484"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datacostbymotor[vehicle.parameters.motor].push({ ...data });
                datacostbyenergy["biogas"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1489"]) {
            vehiclesdata["" + vehicle.id]["1489"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datacostbymotor[vehicle.parameters.motor].push({ ...data });
                datacostbyenergy["electricity"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1494"]) {
            vehiclesdata["" + vehicle.id]["1494"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datacostbymotor[vehicle.parameters.motor].push({ ...data });
                datacostbyenergy["ethanol"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1467"]) {
            vehiclesdata["" + vehicle.id]["1467"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datakmbymotor[vehicle.parameters.motor].push({ ...data });
                datakmbyenergy["SP95"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1472"]) {
            vehiclesdata["" + vehicle.id]["1472"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datakmbymotor[vehicle.parameters.motor].push({ ...data });
                datakmbyenergy["SP98"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1477"]) {
            vehiclesdata["" + vehicle.id]["1477"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datakmbymotor[vehicle.parameters.motor].push({ ...data });
                datakmbyenergy["diesel"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1482"]) {
            vehiclesdata["" + vehicle.id]["1482"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datakmbymotor[vehicle.parameters.motor].push({ ...data });
                datakmbyenergy["hydrogen"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1487"]) {
            vehiclesdata["" + vehicle.id]["1487"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datakmbymotor[vehicle.parameters.motor].push({ ...data });
                datakmbyenergy["biogas"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1492"]) {
            vehiclesdata["" + vehicle.id]["1492"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datakmbymotor[vehicle.parameters.motor].push({ ...data });
                datakmbyenergy["electricity"].push({ ...data });
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1497"]) {
            vehiclesdata["" + vehicle.id]["1497"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                if (!mindates2 || moment(data.date).isBefore(moment(mindates2)))
                  mindates2 = data.date;
                if (!maxdates2 || moment(data.date).isAfter(moment(maxdates2)))
                  maxdates2 = data.date;
                datakmbymotor[vehicle.parameters.motor].push({ ...data });
                datakmbyenergy["ethanol"].push({ ...data });
              }
            });
          }
        }
      });
      // console.log(datacostbymotor);
      // console.log(datacostbyenergy);
      // console.log(mindates2);
      // console.log(maxdates2);
      
      let serieschart1 = [];
      Object.keys(datakmbymotor).forEach(function (key) {
        if (datakmbymotor[key].length > 0 && datacostbymotor[key].length > 0) {
          let totalkm = 0;
          datakmbymotor[key].forEach((data) => { totalkm += Number(data.value) });
          let totalcost = 0;
          datacostbymotor[key].forEach((data) => { totalcost += Number(data.value) });
          let result = (totalcost / totalkm) * 100;
          let serie = {
            color: motorData.find((motor) => motor.id === key).color,
            name: motorData.find((motor) => motor.id === key).name,
            values: [{ value: result }],
          }
          serieschart1.push(serie);
        }
      });
      let chart1tmp = {
        xaxisscale: "",
        name: "Coût par km parcouru et par motorisation",
        type: "piechart",
        defaultoccupationschedule: false,
        distribution: "no",
        yaxis1unit: "c€/km",
        series: [...serieschart1]
      };
      console.log(chart1tmp);
      let chart1result = getChartCategoryScriptV2(chart1tmp, "chart1vehicle"+chartcounttmp, null, true);
      console.log(chart1result);
      setChart1(chart1result);

      mindates2 = moment(mindates2).date(1).unix()*1000;
      maxdates2 = moment(maxdates2).date(1).unix()*1000;
      // console.log(mindates2, maxdates2);
      let serieschart2 = [];
      Object.keys(datacostbyenergy).forEach(function (key) {
        if (datacostbyenergy[key].length > 0) {
          let currentdate = mindates2;
          let values = [];
          while(currentdate<=maxdates2)
          {
            // console.log(currentdate);
            values.push({ time: currentdate, value: 0 })
            currentdate = moment(currentdate).add(1,'month').unix()*1000;
          }
          datacostbyenergy[key].forEach((data) => { 
            let datadate = moment(data.date).date(1).unix()*1000;
            // console.log(datadate);
            if( values.find((val)=>val.time===datadate))
              values.find((val)=>val.time===datadate).value = values.find((val)=>val.time===datadate).value + Number(data.value);
          });
          let seriecost = {
            color: energyData.find((motor) => motor.id === key).color,
            name: energyData.find((motor) => motor.id === key).name,
            values: [...values],
            yaxis: "left",
            type: "line",
            stackId: "a"
          }
          serieschart2.push(seriecost);
        }
        if (datakmbyenergy[key].length > 0) {
          let currentdate = mindates2;
          let values = [];
          while(currentdate<=maxdates2)
          {
            values.push({ time: currentdate, value: 0 })
            currentdate = moment(currentdate).add(1,'month').unix()*1000;
          }
          datakmbyenergy[key].forEach((data) => { 
            let datadate = moment(data.date).date(1).unix()*1000;
            values.find((val)=>val.time==datadate).value = values.find((val)=>val.time==datadate).value + Number(data.value);
          });
          let seriekm = {
            color: energyData.find((motor) => motor.id === key).color,
            name: energyData.find((motor) => motor.id === key).name,
            values: [...values],
            yaxis: "right",
            type: "column",
            stackId: "a"
          }
          serieschart2.push(seriekm);
        }
      });
      console.log(serieschart2);
      let chart2tmp = {
        xaxisscale: "time",
        xaxistimetick: "month",
        name: "Coût et km parcouru par énergie",
        type: "composedchart",
        defaultoccupationschedule: false,
        distribution: "no",
        yaxis1unit: "€ TTC",
        yaxis2: 1,
        yaxis2unit: "km",
        series: [...serieschart2]
      };
      let chart2result = getChartCategoryScriptV2(chart2tmp, "chart2vehicle"+chartcounttmp, null, true);
      setChart2(chart2result);
      setChartcount(chartcounttmp);
    }
  }, [graphdatebegin, graphdateend, vehiclesdata, selectedVehicles, filterText]);


  useEffect(() => {
    if (!filteredItems || filteredItems.length == 0) {
     setFiltereditemwithdata([]);
    }
    else {
      let tmpfiltereditemwithdata = [...filteredItems];
    
      tmpfiltereditemwithdata.forEach((vehicle) => {
        vehicle.cost = 0;
        vehicle.km = 0;
        vehicle.co2 = 0;
        vehicle.time = 0;
        if (vehiclesdata["" + vehicle.id]) {
          if (vehiclesdata["" + vehicle.id]["1464"]) {
            vehiclesdata["" + vehicle.id]["1464"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.cost = (vehicle.cost || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1469"]) {
            vehiclesdata["" + vehicle.id]["1469"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.cost = (vehicle.cost || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1474"]) {
            vehiclesdata["" + vehicle.id]["1474"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.cost = (vehicle.cost || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1479"]) {
            vehiclesdata["" + vehicle.id]["1479"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.cost = (vehicle.cost || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1484"]) {
            vehiclesdata["" + vehicle.id]["1484"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.cost = (vehicle.cost || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1489"]) {
            vehiclesdata["" + vehicle.id]["1489"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.cost = (vehicle.cost || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1494"]) {
            vehiclesdata["" + vehicle.id]["1494"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.cost = (vehicle.cost || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1467"]) {
            vehiclesdata["" + vehicle.id]["1467"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.km = (vehicle.km || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1472"]) {
            vehiclesdata["" + vehicle.id]["1472"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.km = (vehicle.km || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1477"]) {
            vehiclesdata["" + vehicle.id]["1477"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.km = (vehicle.km || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1482"]) {
            vehiclesdata["" + vehicle.id]["1482"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.km = (vehicle.km || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1487"]) {
            vehiclesdata["" + vehicle.id]["1487"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.km = (vehicle.km || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1492"]) {
            vehiclesdata["" + vehicle.id]["1492"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.km = (vehicle.km || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1497"]) {
            vehiclesdata["" + vehicle.id]["1497"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.km = (vehicle.km || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1466"]) {
            vehiclesdata["" + vehicle.id]["1466"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.co2 = (vehicle.co2 || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1471"]) {
            vehiclesdata["" + vehicle.id]["1471"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.co2 = (vehicle.co2 || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1476"]) {
            vehiclesdata["" + vehicle.id]["1476"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.co2 = (vehicle.co2 || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1481"]) {
            vehiclesdata["" + vehicle.id]["1481"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.co2 = (vehicle.co2 || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1486"]) {
            vehiclesdata["" + vehicle.id]["1486"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.co2 = (vehicle.co2 || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1491"]) {
            vehiclesdata["" + vehicle.id]["1491"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.co2 = (vehicle.co2 || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1496"]) {
            vehiclesdata["" + vehicle.id]["1496"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.co2 = (vehicle.co2 || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1465"]) {
            vehiclesdata["" + vehicle.id]["1465"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.time = (vehicle.time || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1470"]) {
            vehiclesdata["" + vehicle.id]["1470"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.time = (vehicle.time || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1475"]) {
            vehiclesdata["" + vehicle.id]["1475"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.time = (vehicle.time || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1480"]) {
            vehiclesdata["" + vehicle.id]["1480"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.time = (vehicle.time || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1485"]) {
            vehiclesdata["" + vehicle.id]["1485"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.time = (vehicle.time || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1490"]) {
            vehiclesdata["" + vehicle.id]["1490"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.time = (vehicle.time || 0) + Number(data.value);
              }
            });
          }
          if (vehiclesdata["" + vehicle.id]["1495"]) {
            vehiclesdata["" + vehicle.id]["1495"].forEach((data) => {
              if (moment(data.date).isSameOrAfter(moment(graphdatebegin)) && moment(data.date).isSameOrBefore(moment(graphdateend))) {
                vehicle.time = (vehicle.time || 0) + Number(data.value);
              }
            });
          }
          if(vehicle.cost && vehicle.km)
          {
            vehicle.costkm = (vehicle.cost/vehicle.km)*100;
          }
        }
      });
     setFiltereditemwithdata(tmpfiltereditemwithdata);
    }
  }, [graphdatebegin, graphdateend, vehiclesdata, filterText]);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `vehicles`, []).filter(
    (item) =>
      (item.registration && item.registration.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.key && item.parameters.key.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.name && item.parameters.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.brand && item.parameters.brand.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.model && item.parameters.model.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.description && item.parameters.description.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.comments && item.parameters.comments.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.idgroup && groupInfoListById["" + item.idgroup] && groupInfoListById["" + item.idgroup].toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.status && statusData.find((x) => x.id == item.parameters.status) && statusData.find((x) => x.id == item.parameters.status).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.motor && motorData.find((x) => x.id == item.parameters.motor) && motorData.find((x) => x.id == item.parameters.motor).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.datebegin && moment(item.parameters.datebegin).isValid() && moment(item.parameters.datebegin).format("DD/MM/YYYY HH:mm").includes(filterText)) ||
      (item.parameters.dateend && moment(item.parameters.dateend).isValid() && moment(item.parameters.dateend).format("DD/MM/YYYY HH:mm").includes(filterText))
  );

  const subHeaderComponentMemo = useMemo(() => {
    console.log("subHeaderComponentMemo",filterText, resetPaginationToggle, selectedVehicles)
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedVehicles.map((item) => {
      let vehicletoexport = {};
      vehicletoexport[vehiclespagetext.registration] = item.registration;
      vehicletoexport[vehiclespagetext.key] = item.parameters.key;
      vehicletoexport[vehiclespagetext.name] = item.parameters.name;
      vehicletoexport[vehiclespagetext.brand] = item.parameters.brand;
      vehicletoexport[vehiclespagetext.model] = item.parameters.model;
      vehicletoexport[vehiclespagetext.description] = item.parameters.description;
      vehicletoexport[vehiclespagetext.motor] = motorData.find((x) => x.id == item.parameters.motor)?.name;
      vehicletoexport[vehiclespagetext.status] = statusData.find((x) => x.id == item.parameters.status)?.name;
      vehicletoexport[vehiclespagetext.datebegin] = (item.parameters.datebegin && moment(item.parameters.datebegin).isValid()) ? moment(item.parameters.datebegin).format("DD/MM/YYYY") : "";
      vehicletoexport[vehiclespagetext.dateend] = (item.parameters.dateend && moment(item.parameters.dateend).isValid()) ? moment(item.parameters.dateend).format("DD/MM/YYYY") : "";
      vehicletoexport[vehiclespagetext.groups] = (item.idgroup && groupInfoListById["" + item.idgroup]) ? groupInfoListById["" + item.idgroup] : "";
      vehicletoexport[vehiclespagetext.comments] = item.parameters.comments;
      return vehicletoexport;
    });

    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {vehiclesadmin && (
          <UploadButton type="button" onClick={handleClear}>
            <CreateVehicle refetch={refreshTable} onClick={handleClear} />
          </UploadButton>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedVehicles || selectedVehicles.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedVehicles]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refreshTable,
    setSelectedVehicles,
    setLoading,
    selectedVehicles,
    graphdatebegin, setGraphdatebegin,
    graphdateend, setGraphdateend,
    chart1, chart2
  };
}
